export interface User {
  Role: string;
  Email: string;
  WWID: string;
}

export const users: User[] = [
  {
    "Role": "repower_view",
    "Email": "okechi.igwebuike@cummins.com",
    "WWID": "kl337@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "harshwardhan.ratnaparkhi@cummins.com",
    "WWID": "ui252@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "rajan.bhagat@cummins.com",
    "WWID": "qp515@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "Eugenia.Stutz@cummins.com",
    "WWID": "rw909@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "scott.a.files@cummins.com",
    "WWID": "s938@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "kedar.gokhale@cummins.com",
    "WWID": "hu276@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "luke.mosier@cummins.com",
    "WWID": "hkv953@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "Deepak.Pillai@cummins.com",
    "WWID": "ie128@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "alan.j.reed@cummins.com",
    "WWID": "ca884@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "Gayathri.Ashok@cummins.com",
    "WWID": "xq626@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "laura.k.chrisman@cummins.com",
    "WWID": "bk900@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "shawn.a.rockey@cummins.com",
    "WWID": "bl916@cummins.com"  
  },
  {
    "Role": "repower_view",
    "Email": "yao.fan@cummins.com",
    "WWID": "sb934@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "abhay.r.lodhi@cummins.com",
    "WWID": "dk583@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "akram.khatib@cummins.com",
    "WWID": "mn106@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "akunor.n.azu@cummins.com",
    "WWID": "cq005@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "audra.henderson@cummins.com",
    "WWID": "kq009@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "alona.pehrson@cummins.com",
    "WWID": "hx672@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "colby.j.christensen@cummins.com",
    "WWID": "fi213@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "ramakrishna.namburi@cummins.com",
    "WWID": "mv773@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "Justin.D.Blomenberg@cummins.com",
    "WWID": "bs978@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "joseph.m.brooks@cummins.com",
    "WWID": "ak952@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "norman.brown.ruiz@cummins.com",
    "WWID": "fz498@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "abhishek.damani@cummins.com",
    "WWID": "jf960@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "mornay.annandale@cummins.com",
    "WWID": "fm103@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "luke.hayward@cummins.com",
    "WWID": "pz521@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "seth.berry@cummins.com",
    "WWID": "pz476@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "eugenia@simadvisory.com",
    "WWID": "eugenia.stutz"
  },
  {
    "Role": "repower_view",
    "Email": "anand.kumar3@cummins.com",
    "WWID": "vt981@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "repowerpredictor@simadvisory.com",
    "WWID": "rpredictor_uat"
  },
  {
    "Role": "repower_view",
    "Email": "nishant.prabhu@cummins.com",
    "WWID": "fo484@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "benjamin.schilling@cummins.com",
    "WWID": "jg893@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "josette.calleja@cummins.com",
    "WWID": "pl443@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "sylvain.godbout@cummins.com",
    "WWID": "ll124@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "barry.r.warn@cummins.com",
    "WWID": "fc102@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "adam.brown@cummins.com",
    "WWID": "cs185@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "corey.kluthe@cummins.com",
    "WWID": "bw565@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "marc.morin@cummins.com",
    "WWID": "cr314@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "pete.maingi@cummins.com",
    "WWID": "ho859@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "randy.washer@cummins.com",
    "WWID": "an28l@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "justin.harkness@cummins.com",
    "WWID": "as03y@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "william.olinger@cummins.com",
    "WWID": "au04m@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "justin.phillips@cummins.com",
    "WWID": "lo703@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "alejandro.garabatos@cummins.com",
    "WWID": "oa979@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "troy.waye@cummins.com",
    "WWID": "ug760@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "ben.simpson@cummins.com",
    "WWID": "gy232@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "paul.morrison@cummins.com",
    "WWID": "jg724@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "luis.e.martinez@cummins.com",
    "WWID": "at767@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "Miguel.Flores@cummins.com",
    "WWID": "kc032@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "rudy.lopez@cummins.com",
    "WWID": "ip942@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "michahely.jimenez@cummins.com",
    "WWID": "bo355@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "yolanda.cortes@cummins.com",
    "WWID": "co545@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "mauricio.ahumada@cummins.com",
    "WWID": "ma499@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "guillermo.bonillas@cummins.com",
    "WWID": "gh369@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "ann-kristin.e.deverdier@cummins.com",
    "WWID": "bu307@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "srikant.gupta@cummins.com",
    "WWID": "ob612@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "goran.galic@cummins.com",
    "WWID": "nq564@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "stefan.wezenbeek@cummins.com",
    "WWID": "ul617@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "david.perkins@cummins.com",
    "WWID": "bd764@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "nikola.kastel@cummins.com",
    "WWID": "nx928@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "cihat.sezgin@cummins.com",
    "WWID": "nf806@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "eddy.bosker@cummins.com",
    "WWID": "cr456@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "kristy.green@cummins.com",
    "WWID": "jo573"
  },
  {
    "Role": "repower_view",
    "Email": "tracey.hockly@cummins.com",
    "WWID": "cp819"
  },
  {
    "Role": "repower_view",
    "Email": "john.tickle@cummins.com",
    "WWID": "ci465"
  },
  {
    "Role": "repower_view",
    "Email": "pallav.pathak@cummins.com",
    "WWID": "lf706"
  },
  {
    "Role": "repower_view",
    "Email": "serkan.arslantas@cummins.com",
    "WWID": "mi365@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "angel.h.rodriguez@cummins.com",
    "WWID": "hh057@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "kweku.winful@cummins.com",
    "WWID": "jo596@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "mehdi.tibri@cummins.com",
    "WWID": "ku027@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "isaac.adusei@cummins.com",
    "WWID": "ju967@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "bontle.mtshengu@cummins.com",
    "WWID": "am65v@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "johan.a.dempers@cummins.com",
    "WWID": "hk555@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "patrice.ndzana@cummins.com",
    "WWID": "jg749@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "raim.omarov@cummins.com",
    "WWID": "su388@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "annie.chu@cummins.com",
    "WWID": "iu892@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "ben.clark@cummins.com",
    "WWID": "co105@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "andriyanto.andriyanto@cummins.com",
    "WWID": "ns850@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "jason.p.linke@cummins.com",
    "WWID": "cu285@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "li.z.zhan@cummins.com",
    "WWID": "hz471@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "li.fuping@cummins.com",
    "WWID": "cn522@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "terrence.q.taylor@cummins.com",
    "WWID": "cd700@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "tinglong.hu@cummins.com",
    "WWID": "ik200@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "chelsea.yuan@cummins.com",
    "WWID": "iy476@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "pankaj.kapoor@cummins.com",
    "WWID": "vy796@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "deenadayalan.mani@cummins.com",
    "WWID": "jf168@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "vinod.r.kuchekar@cummins.com",
    "WWID": "gh114@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "erica.k.baird@cummins.com",
    "WWID": "tg265@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "vivek.malapati@cummins.com",
    "WWID": "fu622@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "stephen.j.cummins@cummins.com",
    "WWID": "ad831@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "lisa.killila@cummins.com",
    "WWID": "ex434@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "camille.hatchett@cummins.com",
    "WWID": "cj609@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "madelyn.pretorius@cummins.com",
    "WWID": "df083@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "bill.a.pearce@cummins.com",
    "WWID": "be455@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "pallavi.sonker@cummins.com",
    "WWID": "kc611@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "alejandro.polanco@cummins.com",
    "WWID": "ia544@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "suchitha.subramanian@cummins.com",
    "WWID": "in343@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "nebil.awad.baqhum@cummins.com",
    "WWID": "gp434@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "diogo.gernhardt@cummins.com",
    "WWID": "qd633@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "regina.barringer@cummins.com",
    "WWID": "cj968@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "aki.bentley@cummins.com",
    "WWID": "he992@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "shanila.s.bhatty@cummins.com",
    "WWID": "fa643@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "mariam.topuria@cummins.com",
    "WWID": "rb857@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "leigha.chadwell@cummins.com",
    "WWID": "ls040@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "guilherme.colloca@cummins.com",
    "WWID": "hg302@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "ginger.lirette@cummins.com",
    "WWID": "bs145@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "ross.kunkler@cummins.com",
    "WWID": "jh467@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "telma.hayashi@cummins.com",
    "WWID": "kg580@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "shane.shi@cummins.com",
    "WWID": "rc139@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "sedad.hadzic@cummins.com",
    "WWID": "ne978@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "baffour.yeboah@cummins.com",
    "WWID": "pp334@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "ioana.i.capelo@cummins.com",
    "WWID": "fm037@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "b.fu@cummins.com",
    "WWID": "nm878@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "ralf.mueller@cummins.com",
    "WWID": "fw129@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "sarah.j.bilston@cummins.com",
    "WWID": "be365@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "sean.lynas@cummins.com",
    "WWID": "ap178@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "alberto.gradara@cummins.com",
    "WWID": "aw150@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "dave.rehse@cummins.com",
    "WWID": "cs046@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "john.mello@cummins.com",
    "WWID": "tx598@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "chris.brown@cummins.com",
    "WWID": "sf547@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "jaouad.ezzarhouni@cummins.com",
    "WWID": "ks427@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "dimitrij.fauser@cummins.com",
    "WWID": "qh952@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "henry.gao@cummins.com",
    "WWID": "mw390@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "chengcheng.gong@cummins.com",
    "WWID": "qe233@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "branda.zhou@cummins.com",
    "WWID": "hr889@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "preetam.ganguly@cummins.com",
    "WWID": "wa075@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "pawan.chadha@cummins.com",
    "WWID": "gm769@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "wale.williams@cummins.com",
    "WWID": "rb567@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "wafa.chanqite@cummins.com",
    "WWID": "nk465@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "hyewon.kwak@cummins.com",
    "WWID": "oz986@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "brendan.laing@cummins.com",
    "WWID": "cr899@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "hernan.anzola@cummins.com",
    "WWID": "sa686@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "Rodrigo.Pineda@cummins.com",
    "WWID": ""
  },
  {
    "Role": "repower_view",
    "Email": "Darlan.Ferreira@cummins.com",
    "WWID": ""
  },
  {
    "Role": "repower_view",
    "Email": "Roberto.Galinari@cummins.com",
    "WWID": ""
  },
  {
    "Role": "repower_view",
    "Email": "yc404@cummins.com",
    "WWID": ""
  },
  {
    "Role": "repower_view",
    "Email": "Setya.Wihananto@cummins.com",
    "WWID": ""
  },
  {
    "Role": "repower_view",
    "Email": "ahmad.s.adam@cummins.com",
    "WWID": "gk753@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "Alvaro.Berenguela@cummins.com",
    "WWID": "am89n@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "ak26l@cummins.com",
    "WWID": "ak26l@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "aq66o@cummins.com",
    "WWID": "aq66o@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "Stephen.Newman@cummins.com",
    "WWID": "am91a@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "molly.puga@cummins.com",
    "WWID": "qz912@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "rajan.bhagat@cummins.com",
    "WWID": "qp515@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "prajwal.kk@simadvisorytech.com",
    "WWID": "prajwal"
  },
  {
    "Role": "repower_view",
    "Email": "aditya.b@simadvisorytech.com",
    "WWID": ""
  },
  {
    "Role": "repower_view",
    "Email": "kristy.green@cummins.com",
    "WWID": "jo573@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "tracey.hockly@cummins.com",
    "WWID": "cp819@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "john.tickle@cummins.com",
    "WWID": "ci465@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "pallav.pathak@cummins.com",
    "WWID": "lf706@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "chernise.naicker@cummins.com",
    "WWID": "op556@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "chetanya.sharma@cummins.com",
    "WWID": "Bd46m@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "pratayksh.mahajan@cummins.com",
    "WWID": "Bd57b@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "venkateswarlu.dunna@cummins.com",
    "WWID": "Bd46l@cummins.com"
  },
  {
    "Role": "repower_view",
    "Email": "gary.beshears@cummins.com",
    "WWID": "ie525@cummins.com"
  }
  


]


export const getMappedRoleByEmail = (email?: string | null): string | null => {
    if (!email) {
        return null;
    }

    const normalizedEmail = email.trim().toLowerCase();
    const matchedUser = users.find((user) => user.Email.toLowerCase() === normalizedEmail);

    return matchedUser?.Role ?? null;
};

export const getMappedRoleForUser = (identity?: {
    email?: string | null;
    wwid?: string | null;
    username?: string | null;
}): string | null => {
    if (!identity) {
        return null;
    }

    const normalizedEmail = identity.email?.trim().toLowerCase();
    const normalizedWwid =
        identity.wwid?.trim().toLowerCase() ||
        identity.username?.trim().toLowerCase();

    const matchedUser = users.find((user) => {
        const userEmail = user.Email?.trim().toLowerCase();
        const userWwid = user.WWID?.trim().toLowerCase();

        return (
            (!!normalizedEmail && userEmail === normalizedEmail) ||
            (!!normalizedWwid && userWwid === normalizedWwid)
        );
    });

    return matchedUser?.Role ?? null;
};
